import { Box, IconButton, Paper, Stack, TextField, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

interface Props {
    block: CTABlock;
    onChange: (content: any) => void;
    onDelete: () => void;
}

const CTABlockEditor = ({ block, onChange, onDelete }: Props) => {
    return (
        <Paper sx={{ p: 2, mb: 2 }}>
            <Stack direction="row" spacing={1} alignItems="flex-start">
                <IconButton size="small" sx={{ cursor: "grab" }}>
                    <DragIndicatorIcon />
                </IconButton>
                <Box flex={1}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold" }}>
                        Call-to-Action Block
                    </Typography>
                    <Stack spacing={2}>
                        <TextField
                            label="Title"
                            value={block.content.title || ""}
                            onChange={(e) =>
                                onChange({
                                    ...block.content,
                                    title: e.target.value,
                                })
                            }
                            fullWidth
                            size="small"
                        />
                        <TextField
                            label="Description"
                            value={block.content.description || ""}
                            onChange={(e) =>
                                onChange({
                                    ...block.content,
                                    description: e.target.value,
                                })
                            }
                            fullWidth
                            size="small"
                            multiline
                            rows={2}
                        />
                        <TextField
                            label="Button Text"
                            value={block.content.buttonText || ""}
                            onChange={(e) =>
                                onChange({
                                    ...block.content,
                                    buttonText: e.target.value,
                                })
                            }
                            fullWidth
                            size="small"
                        />
                        <TextField
                            label="Button URL"
                            value={block.content.buttonUrl || ""}
                            onChange={(e) =>
                                onChange({
                                    ...block.content,
                                    buttonUrl: e.target.value,
                                })
                            }
                            fullWidth
                            size="small"
                        />
                        <TextField
                            label="Background Color (optional)"
                            value={block.content.backgroundColor || ""}
                            onChange={(e) =>
                                onChange({
                                    ...block.content,
                                    backgroundColor: e.target.value,
                                })
                            }
                            fullWidth
                            size="small"
                            helperText="e.g., #f5f5f5, rgba(0,0,0,0.05)"
                        />
                    </Stack>
                </Box>
                <IconButton size="small" onClick={onDelete} color="error">
                    <DeleteIcon />
                </IconButton>
            </Stack>
        </Paper>
    );
};

export default CTABlockEditor;
